//plugins
import { CKEditor } from '@ckeditor/ckeditor5-react'

//providers
import { useTestDataContext } from '../_providers/Test'

const Question = () => {
    const topicData = useTestDataContext()
    const {
        handleActiveSlide,
        handleSlide
    } = topicData

    const handleChange = (_, editor) => {
        if (document.activeElement.classList.contains('ck-content')) changeAction(editor)
    }

    const changeAction = editor => {
        const { name } = editor.config._config
        const value = editor.getData() || ''
        handleSlide()._set(name, value)
    }

    return (
        <CKEditor
            editor={window.BalloonEditor}
            data={handleActiveSlide()._get()._data()?.content?.question || ''}
            config={{
                placeholder: 'Въведете въпрос...',
                name: 'question',
            }}
            onChange={handleChange}
            onBlur={(_, editor) => {
                changeAction(editor)
            }}
        />
    )
}

export default Question